// components/InfoCardBlock.js
import React from "react";
import classess from "../../ApplyNow.module.css";

const InfoCardBlock = ({
  image,
  heading,
  Form,
  CardBelow,
  DownloadLink,

  onButtonClick,
  buttonText,
  belowCardText,
}) => {
  return (
    <>
      {/* Optional Dynamic Page or Header */}
      {/* <DynamicPage title={title} /> */}
      <div className="row align-items-start flex-column flex-lg-row justify-content-center m-0 p-0 text-light">
        <div className="col-lg-4">
          <div
            className={`card`}
            style={{
              //height: "22rem",
              borderRadius: "10px",
              overflow: "hidden",
              border: "none",
            }}
          >
            {heading && (
              <>
                <div
                  className="card-body"
                  style={{
                    backgroundColor: "#113358",
                  }}
                >
                  <p
                    className="card-title text-light text-center"
                    style={{ fontSize: "13px" }}
                  >
                    {heading}
                  </p>
                </div>
              </>
            )}

            <img
              src={image}
              alt="Card visual"
              style={{ height: "100%", width: "100%" }}
            />
          </div>
          {CardBelow && (
            <>
              <div
                className="card"
                style={{ borderRadius: "10px", overflow: "hidden" }}
              >
                <div
                  className="card-heading p-2 text-light text-center"
                  style={{ backgroundColor: "#113358" }}
                >
                  <h4 style={{ lineHeight: "2.5rem", paddingTop: "5px" }}>
                    {CardBelow}
                  </h4>
                </div>
                <div className="card-body">
                  <p>
                    If you would like to fast-track your application, please
                    follow the steps below:{" "}
                  </p>
                  <ol>
                    <li>Download the application form {DownloadLink}</li>
                    <li>Email the PDF form to prop@webridge.co.za</li>
                  </ol>
                </div>
              </div>
            </>
          )}

          {belowCardText && (
            <p className={classess.p}>
              {belowCardText} <br />
              <button className={`btn btn-primary`} onClick={onButtonClick}>
                {buttonText}
              </button>
            </p>
          )}
        </div>

        <div
          className="col-sm-6 col-lg-6 col-md-6 m-0 p-4 flex flex-column justify-content-center"
          style={{ backgroundColor: "#113358", borderRadius: "10px" }}
        >
          {Form}
        </div>
      </div>
    </>
  );
};

export default InfoCardBlock;
